export default __webpack_public_path__ + "static/media/424.17bf7f24.png";